export default __webpack_public_path__ + "static/media/Legit.38ec2f20.svg";